import { useHistory } from 'react-router-dom';
import PaymentBubble from '../PaymentBubble';

export default function StartManufacturingBubble() {
  const history = useHistory();
  const onClickButton = () => {
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>파트너가 제조를 시작했습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={2} />
      <PaymentBubble.Content>
        제조가 완료되면 파트너가 배송을 시작합니다.
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
